import { render, staticRenderFns } from "./BusinessProfile.vue?vue&type=template&id=454e1ce0&scoped=true&"
import script from "./BusinessProfile.vue?vue&type=script&lang=js&"
export * from "./BusinessProfile.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProfile.vue?vue&type=style&index=0&id=454e1ce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e1ce0",
  null
  
)

export default component.exports